import React from 'react';
import TeslaRobot from '../components/TeslaRobot';
import { Link } from 'react-router-dom';

const AboutPage: React.FC = () => {
  return (
    <div className="about-page">
      <div className="about-header">
        <div className="about-title-container">
          <h1 className="about-title">
            About <span className="text-gradient">Digital Workplace</span>
          </h1>
          <p className="about-subtitle">
            The future of work powered by AI and robotics
          </p>
        </div>
        <div className="about-robot">
          <TeslaRobot width={120} height={120} />
        </div>
      </div>

      <div className="about-content">
        <div className="about-section company-section">
          <h2>Our Vision</h2>
          <p>
            Digital Workplace is revolutionizing how businesses operate by providing AI-powered digital employees
            that can handle a wide range of tasks across different departments and industries. Our mission is to
            create a future where human creativity and AI efficiency work together seamlessly.
          </p>
          <p>
            Founded with the belief that the future of work is digital, we've developed a platform that allows
            businesses to build their own digital workforce tailored to their specific needs.
          </p>
        </div>

        <div className="about-section leadership-section">
          <h2>Leadership</h2>
          <div className="leadership-card">
            <div className="leadership-image">
              <div className="leadership-avatar">DF</div>
            </div>
            <div className="leadership-info">
              <h3>David Feld</h3>
              <div className="leadership-title">Creator & CIO</div>
              <p>
                As the visionary behind Digital Workplace, David has pioneered the integration of AI technology
                with business operations. With extensive experience in information technology and artificial intelligence,
                David leads our innovation strategy and technical direction.
              </p>
              <p>
                David's forward-thinking approach has shaped Digital Workplace into a platform that not only meets
                current business needs but anticipates the future of work in an increasingly digital world.
              </p>
            </div>
          </div>
        </div>

        <div className="about-section technology-section">
          <h2>Our Technology</h2>
          <div className="technology-grid">
            <div className="technology-card">
              <div className="technology-icon">🧠</div>
              <h3>Advanced AI</h3>
              <p>
                Our digital employees are powered by state-of-the-art artificial intelligence, capable of learning,
                adapting, and improving over time.
              </p>
            </div>
            <div className="technology-card">
              <div className="technology-icon">🤖</div>
              <h3>Tesla-Inspired Design</h3>
              <p>
                Inspired by Tesla's Optimus robot, our digital employees feature a sleek, modern design that
                represents the cutting edge of technology.
              </p>
            </div>
            <div className="technology-card">
              <div className="technology-icon">🔄</div>
              <h3>Seamless Integration</h3>
              <p>
                Digital employees integrate effortlessly with your existing systems and workflows, providing
                immediate value without disruption.
              </p>
            </div>
            <div className="technology-card">
              <div className="technology-icon">📊</div>
              <h3>Data-Driven Insights</h3>
              <p>
                Our platform provides valuable analytics and insights, helping you optimize your digital workforce
                for maximum efficiency.
              </p>
            </div>
          </div>
        </div>

        <div className="about-section integration-section">
          <h2>API Integration</h2>
          <p>
            Digital Workplace provides comprehensive API capabilities that allow you to seamlessly integrate
            our AI employees with your custom systems and workflows. Our robust API enables you to access
            and control your digital workforce programmatically, making it easy to incorporate AI capabilities
            into your existing infrastructure.
          </p>

          <div className="integration-features">
            <div className="integration-feature">
              <div className="integration-icon">🔗</div>
              <div className="integration-content">
                <h3>RESTful API</h3>
                <p>
                  Our well-documented RESTful API provides secure access to all Digital Workplace features,
                  allowing developers to build custom integrations with ease.
                </p>
              </div>
            </div>

            <div className="integration-feature">
              <div className="integration-icon">💻</div>
              <div className="integration-content">
                <h3>Client Libraries</h3>
                <p>
                  We offer client libraries for popular programming languages including JavaScript, Python,
                  Java, and .NET, making integration simple regardless of your technology stack.
                </p>
              </div>
            </div>

            <div className="integration-feature">
              <div className="integration-icon">🔔</div>
              <div className="integration-content">
                <h3>Webhooks</h3>
                <p>
                  Set up webhooks to receive real-time notifications when specific events occur, enabling
                  your systems to react immediately to changes in your digital workforce.
                </p>
              </div>
            </div>
          </div>

          <div className="api-cta">
            <Link to="/api" className="about-cta-button primary">
              View API Documentation
            </Link>
          </div>
        </div>

        <div className="about-section cta-section">
          <h2>Ready to Transform Your Workplace?</h2>
          <p>
            Discover how Digital Workplace can help your business thrive in the digital age with AI-powered
            employees tailored to your specific needs.
          </p>
          <div className="about-cta-buttons">
            <Link to="/employees" className="about-cta-button primary">
              Explore Digital Employees
            </Link>
            <Link to="/api" className="about-cta-button secondary">
              API Documentation
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
